import React from 'react'

import { NoticeBar, NoticeText } from '~/views/components/NoticeBar'

const NonSupportedBrowserNotice = () => {
  if (typeof window === 'undefined') return null

  const isIE = () => {
    return navigator.userAgent.indexOf('Trident/') !== -1
  }

  return isIE() ? (
    <NoticeBar>
      <NoticeText>
        This browser is outdated and not supported. Please download Google
        Chrome <a href="https://www.google.com/chrome/">here</a>.
      </NoticeText>
    </NoticeBar>
  ) : null
}

export default NonSupportedBrowserNotice
